import { i18n } from '@lingui/core';

export const defaultLocale = 'en';
export async function dynamicActivate(locale) {
  try {
    const { messages } = await import(
      `@ft-frontend/core/src/translations/locales/${locale}/messages`
    );

    try {
      await import(`dayjs/locale/${locale.toLowerCase()}.js`);
    } catch (err) {
      if (locale.indexOf('-') > -1) {
        const [lang, _region] = locale.split('-');

        try {
          await import(`dayjs/locale/${lang.toLowerCase()}.js`);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(
            `Invalid locale for dayjs: ${lang.toLowerCase()} >`,
            err,
          );
        }
      } else {
        // eslint-disable-next-line no-console
        console.error(
          `Invalid locale for dayjs: ${locale.toLowerCase()} >`,
          err,
        );
      }
    }

    i18n.load(locale, messages);
    i18n.activate(locale);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`Invalid locale: ${locale} >`, err);
  }
}
